import React from "react";
import Converge from "../Assets/Consverge.png";
import Atheneum from "../Assets/Atheneum.png";
import Coleman from "../Assets/Coleman.png";
import Capgemini from "../Assets/Capgemini.png";
import GLG from "../Assets/GLC.png"; // Make sure this is named correctly
import ThirdBridge from "../Assets/ThirdBridge.png";

const companies = [
  {
    href: "https://www.converge.com",
    src: Converge,
    alt: "Converge Logo",
  },
  {
    href: "https://www.atheneum.ai",
    src: Atheneum,
    alt: "Atheneum Logo",
  },
  {
    href: "https://www.colemanrg.com",
    src: Coleman,
    alt: "Coleman Logo",
  },
  {
    href: "https://www.capgemini.com",
    src: Capgemini,
    alt: "Capgemini Logo",
  },
  {
    href: "https://www.glginsights.com",
    src: GLG,
    alt: "GLG Logo",
  },
  {
    href: "https://www.thirdbridge.com",
    src: ThirdBridge,
    alt: "Third Bridge Logo",
  },
];

const CompanyLogos = () => {
  return (
    <div className="bg-neutral-100 py-8 px-4 sm:px-6 lg:px-8 my-20">
      <div className="flex flex-start justify-center w-full overflow-x-scroll scrollbar-hide gap-6 sm:gap-10 md:gap-12 lg:gap-16 items-center">
        {companies.map((company, index) => (
          <a
            key={index}
            href={company.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center transition-transform hover:scale-105"
          >
            <img
              src={company.src}
              alt={company.alt}
              className="h-8 sm:h-10 md:h-12 lg:h-14 w-auto object-contain"
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default CompanyLogos;
